import { ExternalServiceEntry } from "./extraServicesTypes"

/** Stable MRT row id so extra-service rows keep identity across reorders. */
export const getExtraServiceRowId = (row: ExternalServiceEntry): string => String(row.id)

/** Move the dragged extra service to the target's position (pure, for optimistic reorder). */
export function reorderExtraServices(
    services: ExternalServiceEntry[],
    draggingItem: ExternalServiceEntry,
    targetItem: ExternalServiceEntry,
): ExternalServiceEntry[] {
    const fromIndex = services.findIndex((service) => service.id === draggingItem.id)
    const toIndex = services.findIndex((service) => service.id === targetItem.id)

    if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) {
        return services
    }

    const next = [...services]
    const [moved] = next.splice(fromIndex, 1)
    next.splice(toIndex, 0, moved)

    return next
}

